import { useState } from "react";
import { noRecordsAlert } from "../../../../../../_helpers/Helpers";
import { ParentUsersUIProvider } from "./ParentUsersUIContext";
import { ParentUsersCard } from "./ParentUsersCard";
import { IPListEdit } from "../IP-list-edit/IPListEdit";

export function ParentUsersPage() {
  const [ids, setIds] = useState();
  const [showIPListEdit, setShowIPListEdit] = useState();
  const closeIPListEdit = () => setShowIPListEdit(false);
    
  const parentUsersUIEvents = {
    openIPListEditModal: (ids) => {
      if (typeof ids === 'string') ids = ids.split(",");
              
      if (ids.length < 1) {
        noRecordsAlert();
        return;
      }
      setIds(ids);
      setShowIPListEdit(true);
    }
  };

  return (
    <ParentUsersUIProvider parentUsersUIEvents={parentUsersUIEvents}>
      <IPListEdit
        ids={ids}
        showIPListEdit={showIPListEdit}
        closeIPListEdit={closeIPListEdit}
      />
      <ParentUsersCard />
    </ParentUsersUIProvider>
 );
}